// All API paths derive from `API_URL` (+ /api/v1). Kept in its own module so
// both the generic client and the auth/session bootstrap can import it without
// a circular dependency.
const root = (import.meta.env.API_URL ?? "").replace(/\/+$/, "");

export const API_BASE = `${root}/api/v1`;
